import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { useLocation } from "react-router-dom";

const EASE_OUT = [0.22, 1, 0.36, 1];
const EASE_IN = [0.4, 0, 1, 1];

export const PageTransition = ({ children }) => {
  const { pathname } = useLocation();
  const reduce = useReducedMotion();
  const variants = reduce
    ? { initial: { opacity: 0 }, enter: { opacity: 1, transition: { duration: 0.25 } }, exit: { opacity: 0, transition: { duration: 0.2 } } }
    : {
        initial: { opacity: 0, y: 20, scale: 0.994, filter: "blur(6px)" },
        enter: { opacity: 1, y: 0, scale: 1, filter: "blur(0px)", transition: { duration: 0.42, ease: EASE_OUT, opacity: { duration: 0.3 } } },
        exit: { opacity: 0, y: 12, scale: 0.99, filter: "blur(4px)", transition: { duration: 0.18, ease: EASE_IN } },
      };
  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div key={pathname} variants={variants} initial="initial" animate="enter" exit="exit" style={{ willChange: "opacity, transform, filter" }} data-testid="page-transition">
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default PageTransition;
